
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import MasterFSPMaintenance from "./MasterFSPMaintenance";
import { MasterFSPMaintenanceFormPanel } from "./MasterFSPMaintenanceFormPanel";

export const MasterFSPMasterView: React.FC = () => {
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    // const { isAdd } = masterFSPState.masterState;
    const { isShowEditPanel } = masterFSPState;

    return <>
        <div className="main-comp-wrapper im-hide-side-form-draggable">
            <MasterFSPMaintenance/>
            {
                (isShowEditPanel && 
                <SliderPanel
                    isOpen={false}
                    leftSectionWidth={"100%"}
                    rightSectionWidth={"0%"}
                    leftChildren={<MasterFSPMaintenanceFormPanel/>}
                />
                )
            }
        </div>
    </>
}